<template>
  <span class="h-36px dib" :class="selectStandardProps?.width || 'w-200px'">
    <el-select
      v-model="standardId"
      filterable
      size="small"
      class="w-full"
      @change="changeStandardId"
      :popper-class="selectStandardProps?.popperClass"
    >
      <el-option
        v-for="item in standardList"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-select>
  </span>
</template>

<script>
import StandardManagementService from '@/services/common/StandardManagementService'
import getSystemParams from './systemParams'

export default {
  props: {
    selectStandardProps: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      standardId: localStorage.getItem('standardId') || '',
      standardList: JSON.parse(localStorage.getItem('standardList')) || [],
      currentSiteId: '', // 当前系统id
      currentTenantId: '', // 当前租户id
    }
  },
  watch: {
    currentSiteId: {
      async handler(newVal) {
        const oldSiteId = await localStorage.getItem('oldSiteId')
        if (this.currentSiteId && oldSiteId && this.currentSiteId !== oldSiteId) {
          localStorage.setItem('oldSiteId', newVal)
          this.clearStandard()
        }
        if (newVal) {
          localStorage.setItem('oldSiteId', newVal)
        }
      },
      immediate: true,
    },
    currentTenantId: {
      async handler(newVal) {
        if (newVal) {
          console.log(newVal, '000')
          const oldTenantId = await localStorage.getItem('oldTenantId')
          if (
            (this.currentTenantId && oldTenantId && this.currentTenantId !== oldTenantId) ||
            (this.currentTenantId && !oldTenantId) ||
            (!this.currentTenantId && oldTenantId)
          ) {
            localStorage.setItem('oldTenantId', newVal)
            this.clearStandard()
          }
          if (newVal) {
            localStorage.setItem('oldTenantId', newVal)
          }
        }
      },
      immediate: true,
    },
  },
  created() {
    this.currentTenantId = localStorage.getItem('CurrentUser')
      ? localStorage.getItem('TenantId') || ''
      : null
    const standardList = localStorage.getItem('standardList')
      ? JSON.parse(localStorage.getItem('standardList'))
      : ''
    if (!standardList && !this.currentTenantId) {
      this.getStandardList()
      // 获取系统参数
      getSystemParams()
    }
  },
  mounted() {},
  methods: {
    // 清除缓存数据，重新获取标准列表
    clearStandard() {
      localStorage.removeItem('standardList')
      localStorage.removeItem('standardCode')
      localStorage.removeItem('standardId')
      this.getStandardList()
    },
    // 获取标准库
    async getStandardList() {
      this.standardList = []
      const res = await StandardManagementService.getList()
      if (res && res.data && res.code === 0) {
        this.standardList = _.map(res.data, (item) => {
          return {
            name: item.name,
            code: item.code,
            id: item.id,
          }
        })
        localStorage.setItem('standardList', JSON.stringify(this.standardList))
        this.$emit('updateStandardList', this.standardList)
        const standardId = localStorage.getItem('standardId')
        if (standardId) {
          this.standardId = standardId
        } else {
          this.standardId = res.data.length > 0 ? res.data[0].id : ''
        }
        localStorage.setItem('standardId', this.standardId)
        if (!this.standardId) {
          this.$emit('updateStandardId', '')
          return
        }
        this.standardList.forEach((item) => {
          if (item.id === this.standardId) {
            localStorage.setItem('standardCode', item.code)
            this.$emit('updateStandardId', this.standardId, item.code)
          }
        })
      }
    },
    changeStandardId(val) {
      localStorage.setItem('standardId', val)
      let standardCode = null
      this.standardList.forEach((item) => {
        if (item.id === val) {
          standardCode = item.code
          localStorage.setItem('standardCode', item.code)
        }
      })
      this.$emit('updateStandardId', val, standardCode)
    },
  },
  async activated() {
    // this.currentSiteId = await localforage.getItem('currentSiteId')
    // this.standardList = await JSON.parse(localStorage.getItem('standardList'))
    // this.standardId = localStorage.getItem('standardId')
  },
}
</script>
